module.exports = __webpack_public_path__ + "static/Circo-1345eda8cde0198c90e84d4a497a3a8b.jpg";